import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { MAX_PAGE_SIZE_DEFAULT } from '~/constants/srp';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { usePagination } from '~/context/srp/InventoryContext';
import SEOContext from '~/context/srp/SEOContext';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';

export default function useSetPageNumber() {
  const { setPageNumber } = useContext(AppliedFiltersContext);
  const { setChanged } = useContext(SEOContext);
  const { currentPage: pageNumberFromInventory } = usePagination();

  const { request } = useGenerateInventoryRequest(MAX_PAGE_SIZE_DEFAULT, {
    includePageNumber: false
  });

  // Reset when something changes, e.g. filters, sort, or trade-in
  useSubsequentEffect(() => {
    setChanged();
    setPageNumber(1);
  }, [request, setChanged, setPageNumber]);

  // Synchronize with Search API response
  useSubsequentEffect(() => {
    if (pageNumberFromInventory) {
      setPageNumber(pageNumberFromInventory);
    }
  }, [pageNumberFromInventory, setPageNumber]);
}
